export const isObject = (value: unknown): boolean => {
  const type = typeof value;
  return value !== undefined && value != null && !Array.isArray(value) && (type === 'object' || type === 'function');
};

export const isEmpty = (value: object): boolean => Object.keys(value).length === 0;

export const isArrayOfObjects = (arr: unknown[]): boolean => arr.every(element => isObject(element));
